<template>
  <div>
    <ContentGeneratorSection
      v-for="(section, index) in sections"
      :key="index"
      :section="section"
    />
  </div>
</template>

<script>
import ContentGeneratorSection from './Section.vue'
export default {
  components: {
    ContentGeneratorSection
  },
  props: {
    sections: {
      type: Array,
      default: () => []
    }
  }
}
</script>
